import React from 'react';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import '@trp-beacon-ui-kit/foundation/css/style.css';
import { Box, Grid, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import AlertBell from '../../../assets/images/AlertBell.svg';
import { accountCenter } from '../Links';

import { PsBeaconButton } from '../BeaconRegister';

const YodleeAlert = ({ dispatch }) => {
    const setSessionDismissal = () => {
        window.sessionStorage.setItem("showYodleeModal", false)
        dispatch({
            type: 'YODLEE_MODAL',
            showYodleeModal: false
        });
    };

    const accCentOnClick = () => {
        setSessionDismissal();
        window.open(accountCenter, '_blank');
    }

    return (
        <Box
            id='yodlee-alert'
            className='beacon-theme-modern-outlook beacon-on-light b-container-content b-reset'
            sx={{
                padding: '24px 32px 24px 28.62px',
                border: '1px solid #086EA1',
                borderRadius: '4px'
            }}
        >
            <Box display='flex'>
                <Grid container>
                    <Grid item cols={12} xl={9} size={{ xs: 12, lg: 9 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', paddingRight: '12px' }} id='yodlee-alert-content'>
                        <Box>
                            <img
                                id="alarm-bell-icon"
                                alt="alarm-bell-icon"
                                style={{
                                    minHeight: 52,
                                    minWidth: 52,
                                    paddingRight: 16
                                }}
                                src={AlertBell}
                            />
                        </Box>
                        <Box>
                            <Box>
                                <Typography
                                    id='yodlee-alert-title'
                                    type="body" loose scale={100} light
                                >
                                    Please revalidate outside financial account information.
                                </Typography>
                            </Box>
                            <Box>
                                <Typography
                                    id='yodlee-alert-subtitle'
                                    type="body" loose scale={100} light
                                    sx={{ marginBottom: '16px' }}
                                >
                                    One or more of the outside financial accounts you linked for inclusion in your Financial Plan requires attention.
                                    You can provide updated information to resolve the issue from your Account Center.
                                </Typography>
                            </Box>
                        </Box>
                        </Box>
                    </Grid>
                    <Grid item cols={12} md={4} xl={3}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Box id='yodlee-alert-dismiss-button-container'>
                            <PsBeaconButton
                                id='yodlee-alert-dismiss-button'
                                variant='tertiary'
                                onClick={setSessionDismissal}
                            >
                                Dismiss
                            </PsBeaconButton>
                        </Box>
                        <Box>
                            <PsBeaconButton
                                id='yodlee-alert-ac-button'
                                variant='primary'
                                onClick={accCentOnClick}
                                style={{ whiteSpace: 'nowrap' }}
                            >
                                Go to Account Center
                            </PsBeaconButton>
                        </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )
};

export default YodleeAlert;
